import { z } from 'zod';
/**
 * Public: payload the user submits from the reset-password page. The token
 * comes from the emailed link; the password follows the same rules as the
 * change-password flow (min 8, one uppercase, one digit).
 */
export const resetPasswordConfirmSchema = z.object({
    token: z.string().min(1, 'Token requerido'),
    password: z
        .string()
        .min(8, 'La contraseña debe tener al menos 8 caracteres')
        .regex(/[A-Z]/, 'Debe contener al menos una mayúscula')
        .regex(/[0-9]/, 'Debe contener al menos un número'),
});
//# sourceMappingURL=password-reset.schema.js.map